<mat-icon [svgIcon]="iconName" *ngIf="type=='custom'||type=='svg'"></mat-icon>
<mat-icon *ngIf="type=='google'" color="primary" [ngStyle]="{'color':color}">{{iconName}}</mat-icon>
<fa-icon [icon]="iconName" *ngIf="type=='fa'"  [ngStyle]="{'color':color}"></fa-icon>